module.exports = __webpack_public_path__ + "static/img/101377.c858515f.png";